import { render, staticRenderFns } from "./DataConsent.vue?vue&type=template&id=52ab5bb1&scoped=true"
import script from "./DataConsent.vue?vue&type=script&lang=js"
export * from "./DataConsent.vue?vue&type=script&lang=js"
import style0 from "./DataConsent.vue?vue&type=style&index=0&id=52ab5bb1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab5bb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ab5bb1')) {
      api.createRecord('52ab5bb1', component.options)
    } else {
      api.reload('52ab5bb1', component.options)
    }
    module.hot.accept("./DataConsent.vue?vue&type=template&id=52ab5bb1&scoped=true", function () {
      api.rerender('52ab5bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/Candidate/Form/DataConsent.vue"
export default component.exports